import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { ClockComponentDefaultBox } from "./clock.component.default.box";
import { ClockComponentSICisBox } from "./clock.component.siCis.box";

export const ClockComponentBox = styledByTheme(ClockComponentDefaultBox)
    .forSICis(ClockComponentSICisBox)
    .apply();